const toTitleCase = (value: string): string => {
  return value
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map((part) => {
      const firstChar = part.charAt(0);
      const rest = part.slice(1);
      return `${firstChar.toUpperCase()}${rest}`;
    })
    .join(" ");
};

export default toTitleCase;
